var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangeOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 13c1.1045695 0 2 .8954305 2 2v4c0 1.1045695-.8954305 2-2 2H10c-1.1045695 0-2-.8954305-2-2v-4c0-1.1045695.8954305-2 2-2h11zM6 5.995v2H4c-.51283584 0-.93550716.38604019-.99327227.88337887L3 8.995v6c0 .5128358.38604019.9355072.88337887.9932723L4 15.995h2v2H4c-1.59768088 0-2.90366088-1.24892-2.99490731-2.8237272L1 14.995v-6c0-1.59768088 1.24891996-2.90366088 2.82372721-2.99490731L4 5.995h2zM21 3c1.1045695 0 2 .8954305 2 2v4c0 1.1045695-.8954305 2-2 2H10c-1.1045695 0-2-.8954305-2-2V5c0-1.1045695.8954305-2 2-2h11z",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeOrder);
export default __webpack_public_path__ + "static/media/changeOrder.1ef1e072.svg";
export { ForwardRef as ReactComponent };